export const ACTIONS = {
  CHANGE_PASSWORD: "change_password",
  GET_PIN_CODE: "gch/get_pin_code",
  GET_CITIES: "gch/get_cities",
  GET_AREA: "gch/get_area",
  GET_AGENTS: "gch/get_agents",
  GET_AGENTS_BY_USERGROUP: "gch/get_agents_by_usergroup",
  GET_PANEL_USERS: "gch/get_panel_user",
  CREATE_USERS: "gch/create_users",
  GET_USERS_RIGHTS: "gch/get_users_rights",
  GET_BOOKING_STATUS_COUNT: "gch/get_booking_status_count",
  GET_BOOKING_OVERVIEW: "gch/booking_overview",
  CREATE_CLIENT: "gch/create_client",
  GET_CLIENT: "gch/get_client",
  UPDATE_CLIENT: "gch/update_client",
  CREATE_DEALER: "gch/create_dealer",
  UPDATE_DEALER: "gch/update_dealer",
  GET_DEALER: "gch/get_dealer",
  CREATE_INSTITUE: "gch/create_institue",
  UPDATE_INSTITUTE: "gch/update_institute",
  GET_INSTITUTE: "gch/get_institute",
  GET_SAMPLE_ACCESSIONING: "gch/get_sample_accessioning",
  UPDATE_SAMPLES_ACCESSIONING: "gch/update_samples_accessioning",
  CREATE_SAMPLE_ACESSIONING: "gch/sample_acessioning",
  CREATE_PROJECT: "gch/create_project,",
  UPDATE_PROJECT: "gch/update_project",
  GET_PROJECTS: "gch/get_projects",
  GET_APPLICATIONS: "gch/get_applications",
  GET_DISPLAY_CITIES: "gch/get_display_cities",
  UPLOAD_MEDIA_FILES: "gch/upload_files",
  GET_UPLOAD_MEDIA: "gch/get_upload_media",
  GET_SAMPLE_ACCESSIONING_FILTER: "gch/get_sample_accessioning_filter",
  GET_PROJECTS_FILTER: "gch/get_projects_filter",
  CREATE_FAILED_SAMPLES_NAMES: "create_failed_sample_names",
  GET_FAILED_SAMPLES: "gch/get_failed_samples",
  SET_LOADING: "gch/set_loading",
  GET_USER_DETAILS: "gch/get_user_details",
  GET_PROJECT_SAMPLES: "gch/get_project_samples",
  GET_PROJECTS_SAMPLE_ALL_DATA: "gch/get_project_sample_all_data",
  GET_TICKETS: "gch/get_ticket",
  CREATE_TICKET: "gch/create_ticket",
  UPDATE_TICKET: "gch/update_ticket",
  GET_LOGIN_USER: "gech/get_login_user",
  UPDATE_STATUS_CLOSED: "gech/update_status_closed",
  GET_COMMENTS:"gech/get_comments",
  UPDATE_COMMENTS:"gech/update_comments",
  GET_STATUS_BY_YEAR:"gch/get_status_by_year",
  SEND_FILE_SHARE:"gch/send_file_share",
};
interface CreateClient {
  type: typeof ACTIONS.CREATE_CLIENT;
  payload: boolean;
}
interface fileShare {
  type: typeof ACTIONS.SEND_FILE_SHARE;
  payload: Object;
}
interface updateComments {
  type: typeof ACTIONS.UPDATE_COMMENTS;
  payload: Object;
}
interface getStatusYear {
  type: typeof ACTIONS.GET_STATUS_BY_YEAR;
  payload: Object;
}
interface getComments {
  type: typeof ACTIONS.GET_COMMENTS;
  payload: Object;
}
interface updateCloesdStatus {
  type: typeof ACTIONS.UPDATE_STATUS_CLOSED;
  payload: Object;
}
interface getUser {
  type: typeof ACTIONS.GET_LOGIN_USER;
  payload: Object;
}
interface UpdateTicket {
  type: typeof ACTIONS.UPDATE_TICKET;
  payload: Object;
}
interface GetTicket {
  type: typeof ACTIONS.GET_TICKETS;
  payload: Object;
}
interface createTicket {
  type: typeof ACTIONS.CREATE_TICKET;
  payload: Object;
}
interface GetAllsampleData {
  type: typeof ACTIONS.GET_PROJECTS_SAMPLE_ALL_DATA;
  payload: Object;
}
interface GetUserDetails {
  type: typeof ACTIONS.GET_USER_DETAILS;
  payload: Object;
}
interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}
interface CreateFailedSamples {
  type: typeof ACTIONS.CREATE_FAILED_SAMPLES_NAMES;
  payload: boolean;
}
interface GetFailedSamples {
  type: typeof ACTIONS.GET_FAILED_SAMPLES;
  payload: boolean;
}
interface GetUploadMedia {
  type: typeof ACTIONS.GET_UPLOAD_MEDIA;
  payload: boolean;
}
interface GetProjectFilter {
  type: typeof ACTIONS.GET_PROJECTS_FILTER;
  payload: boolean;
}
interface GetSampleFilter {
  type: typeof ACTIONS.GET_SAMPLE_ACCESSIONING_FILTER;
  payload: boolean;
}
interface UploadMediaFiles {
  type: typeof ACTIONS.UPLOAD_MEDIA_FILES;
  payload: boolean;
}
interface GetDisplayCities {
  type: typeof ACTIONS.GET_DISPLAY_CITIES;
  payload: boolean;
}
interface CreateProject {
  type: typeof ACTIONS.CREATE_PROJECT;
  payload: boolean;
}
interface GetApplications {
  type: typeof ACTIONS.GET_APPLICATIONS;
  payload: boolean;
}
interface GetProject {
  type: typeof ACTIONS.GET_PROJECTS;
  payload: boolean;
}
interface UpdateProject {
  type: typeof ACTIONS.CREATE_PROJECT;
  payload: boolean;
}
interface CreateInstitute {
  type: typeof ACTIONS.CREATE_INSTITUE;
  payload: boolean;
}
interface CreateSampleAcessioning {
  type: typeof ACTIONS.CREATE_SAMPLE_ACESSIONING;
  payload: boolean;
}
interface UpdateSamplesAccessioning {
  type: typeof ACTIONS.UPDATE_SAMPLES_ACCESSIONING;
  payload: boolean;
}
interface GetSampleAccessioning {
  type: typeof ACTIONS.GET_SAMPLE_ACCESSIONING;
  payload: boolean;
}
interface GetInstitute {
  type: typeof ACTIONS.GET_INSTITUTE;
  payload: boolean;
}
interface UpdateInstitute {
  type: typeof ACTIONS.UPDATE_INSTITUTE;
  payload: boolean;
}
interface GetDealer {
  type: typeof ACTIONS.GET_DEALER;
  payload: boolean;
}
interface CreateDealer {
  type: typeof ACTIONS.UPDATE_DEALER;
  payload: boolean;
}
interface CreateDealer {
  type: typeof ACTIONS.CREATE_DEALER;
  payload: boolean;
}
interface UpdateClient {
  type: typeof ACTIONS.UPDATE_CLIENT;
  payload: boolean;
}
interface GetClient {
  type: typeof ACTIONS.GET_CLIENT;
  payload: boolean;
}
interface GetBookingStatusCount {
  type: typeof ACTIONS.GET_BOOKING_STATUS_COUNT;
  payload: Array<any>;
}
interface GetBookingOverview {
  type: typeof ACTIONS.GET_BOOKING_OVERVIEW;
  payload: Array<any>;
}
interface GetUsersRights {
  type: typeof ACTIONS.GET_USERS_RIGHTS;
  payload: boolean;
}

interface CreateUsers {
  type: typeof ACTIONS.CREATE_USERS;
  payload: boolean;
}
interface GetBookingStatusCount {
  type: typeof ACTIONS.GET_BOOKING_STATUS_COUNT;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}
interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}

interface GetAgents {
  type: typeof ACTIONS.GET_AGENTS;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}
interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}
interface GetAgents {
  type: typeof ACTIONS.GET_AGENTS;
  payload: Array<any>;
}
interface GetAgentByUserGroup {
  type: typeof ACTIONS.GET_AGENTS_BY_USERGROUP;
  payload: Object;
}
interface ProjectSamples {
  type: typeof ACTIONS.GET_PROJECT_SAMPLES;
  payload: Object;
}
export type PhleboAdminTypes =
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | GetAgents
  | GetAgentByUserGroup
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | GetAgents
  | GetBookingStatusCount
  | GetUsersRights
  | CreateUsers
  | GetBookingOverview
  | CreateClient
  | GetClient
  | UpdateClient
  | CreateDealer
  | GetDealer
  | CreateInstitute
  | UpdateInstitute
  | GetInstitute
  | GetSampleAccessioning
  | UpdateSamplesAccessioning
  | CreateSampleAcessioning
  | CreateProject
  | UpdateProject
  | GetProject
  | GetApplications
  | GetDisplayCities
  | UploadMediaFiles
  | GetUploadMedia
  | GetSampleFilter
  | GetProjectFilter
  | CreateFailedSamples
  | GetFailedSamples
  | SetLoading
  | GetUserDetails
  | ProjectSamples
  | GetAllsampleData
  | GetTicket
  | createTicket
  | UpdateTicket
  | getUser
  | updateCloesdStatus
  | getComments
  | updateComments
  | getStatusYear
  | fileShare






